<div>
    <div>
        <img class='img-numero-cliente' src='../../../assets/img/conoce-numero-cliente2025.jpg' alt="Conoce tu número de cliente">
    </div>
    <p class="texto-numero-cliente">
    Si no tienes tu número de cliente obtenlo ingresando tu dirección en metrogas.cl
    </p>
    <div class="callToAcction">
        <input type="button" value="CONTINUAR" class="btn btn-continuar center" (click)="modalCallejeroMostrarNumeroCliente()">
    </div>
    <br>
</div>    


<!--
<div class="modal-numero-cliente">
    <div class="punto-informacion">
        <img class='img-numero-cliente' src='./assets/img/conoce-numero-cliente.jpg' alt="Conoce tu número de cliente">
        <br>
        <p class="texto-numero-cliente">
        Si no tienes tu número de cliente obtenlo ingresando tu dirección en metrogas.cl
        </p>
        <div class="callToAcction">
        <button class="btn btn-continuar center" id="openModalButton">CONTINUAR</button>
        </div>
        <br>
    </div>
</div>
-->